import React from "react";

export const RequestItem = ({ request }) => {
  const notificationBadge = request.status;
  return (
    <div className="flex  flex-col items-start gap-2 sm:flex-row   sm:justify-between p-2 py-4 text-f14 sm:items-center">
      <div>
        <h4 className="text-start text-secondarytwo pb-1 text-f14 font-normal capitalize">
          <b>{(request?.companyID?.new_company == 1 && request.request_type === "Claim Company") ? "Create Business" : request.request_type === "Claim Company" ? "Claim Business" : request.request_type}</b>
          <div>
            {request?.companyName || `${request?.companyID &&
              " (" + request?.companyID.registered_company_name + ") "
              }`}
          </div>
        </h4>
        <div className="flex items-center gap-1">
          <span>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8.00065" cy="8.50065" r="6.66667" stroke="#5B8098" />
              <path
                d="M8 5.83398V8.50065L9.66667 10.1673"
                stroke="#5B8098"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="text-secondary tracking-subheading">
            {request.date_of_req}
          </span>
        </div>
      </div>
      <div
        className={`py-1 px-4 ${notificationBadge === "Completed"
          ? "bg-success"
          : (notificationBadge === "pending" || notificationBadge === "Modified")
            ? "bg-inProgress"
            : notificationBadge === "sent"
              ? "bg-sent"
              : "bg-decline"
          } rounded-full text-red-900 font-semibold flex gap-1 items-center`}
      >
        <span>
          <svg
            className={`${notificationBadge === "Completed"
              ? "stroke-success"
              : (notificationBadge === "pending" || notificationBadge === "Modified")
                ? "stroke-inProgress"
                : notificationBadge === "sent"
                  ? "stroke-sent"
                  : "stroke-decline"
              }`}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.51991 2.59286C6.89582 2.27251 7.08378 2.11233 7.2803 2.01841C7.73483 1.80116 8.26323 1.80116 8.71776 2.01841C8.91428 2.11233 9.10224 2.27251 9.47815 2.59286C9.62777 2.72036 9.70258 2.78411 9.78247 2.83766C9.96561 2.96041 10.1713 3.04561 10.3876 3.08831C10.4819 3.10694 10.5799 3.11476 10.7759 3.1304C11.2682 3.16968 11.5144 3.18933 11.7198 3.26187C12.1948 3.42965 12.5684 3.80329 12.7362 4.27831C12.8087 4.48369 12.8284 4.72985 12.8677 5.22219C12.8833 5.41814 12.8911 5.51612 12.9098 5.61048C12.9525 5.82677 13.0376 6.03245 13.1604 6.21559C13.2139 6.29549 13.2777 6.37029 13.4052 6.51991C13.7256 6.89582 13.8857 7.08378 13.9797 7.2803C14.1969 7.73483 14.1969 8.26323 13.9797 8.71776C13.8857 8.91428 13.7256 9.10224 13.4052 9.47815C13.2777 9.62777 13.2139 9.70258 13.1604 9.78247C13.0376 9.96561 12.9525 10.1713 12.9098 10.3876C12.8911 10.4819 12.8833 10.5799 12.8677 10.7759C12.8284 11.2682 12.8087 11.5144 12.7362 11.7198C12.5684 12.1948 12.1948 12.5684 11.7198 12.7362C11.5144 12.8087 11.2682 12.8284 10.7759 12.8677C10.5799 12.8833 10.4819 12.8911 10.3876 12.9098C10.1713 12.9525 9.96561 13.0376 9.78247 13.1604C9.70258 13.2139 9.62777 13.2777 9.47815 13.4052C9.10224 13.7256 8.91428 13.8857 8.71776 13.9797C8.26323 14.1969 7.73483 14.1969 7.2803 13.9797C7.08378 13.8857 6.89582 13.7256 6.51991 13.4052C6.37029 13.2777 6.29549 13.2139 6.21559 13.1604C6.03245 13.0376 5.82677 12.9525 5.61048 12.9098C5.51612 12.8911 5.41814 12.8833 5.22219 12.8677C4.72985 12.8284 4.48369 12.8087 4.27831 12.7362C3.80329 12.5684 3.42965 12.1948 3.26187 11.7198C3.18933 11.5144 3.16968 11.2682 3.1304 10.7759C3.11476 10.5799 3.10694 10.4819 3.08831 10.3876C3.04561 10.1713 2.96041 9.96561 2.83766 9.78247C2.78411 9.70258 2.72036 9.62777 2.59286 9.47815C2.27251 9.10224 2.11233 8.91428 2.01841 8.71776C1.80116 8.26323 1.80116 7.73483 2.01841 7.2803C2.11233 7.08378 2.27251 6.89582 2.59286 6.51991C2.72036 6.37029 2.78411 6.29549 2.83766 6.21559C2.96041 6.03245 3.04561 5.82677 3.08831 5.61048C3.10694 5.51612 3.11476 5.41814 3.1304 5.22219C3.16968 4.72985 3.18933 4.48369 3.26187 4.27831C3.42965 3.80329 3.80329 3.42965 4.27831 3.26187C4.48369 3.18933 4.72985 3.16968 5.22219 3.1304C5.41814 3.11476 5.51612 3.10694 5.61048 3.08831C5.82677 3.04561 6.03245 2.96041 6.21559 2.83766C6.29549 2.78411 6.37029 2.72036 6.51991 2.59286Z"
              stroke=""
            />
            <path
              d="M5.66602 8.33398L6.99935 9.66732L10.3327 6.33398"
              stroke=""
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span
          className={`${notificationBadge === "Completed"
            ? "text-success"
            : (notificationBadge === "pending" || notificationBadge === "Modified")
              ? "text-inProgress"
              : notificationBadge === "sent"
                ? "text-sent"
                : "text-decline"
            } tracking-subheading uppercase text-f14`}
        >
          {notificationBadge === "Completed"
            ? "Completed"
            : notificationBadge === "pending"
              ? "IN PROGRESS" : notificationBadge === "Modified" ? "MODIFIED"
                : notificationBadge === "sent"
                  ? "REQUEST SENT"
                  : request.request_type == "Claim Company"
                    ? "DECLINED"
                    : "DECLINED"}
        </span>
      </div>
    </div>
  );
};
